import { FC, useCallback, useState } from 'react';

import { ModalsContext, ModalState } from './ModalsContext';

export const ModalsContextProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const [modalState, showModal] = useState<ModalState>();
  const hideModal = useCallback(() => showModal(undefined), []);

  return (
    <ModalsContext.Provider
      value={{
        showModal,
        hideModal,
        modalState,
      }}
    >
      {children}
    </ModalsContext.Provider>
  );
};
